import React from 'react';
import { fetchUsers } from '../services/user_services';
import { InputTypeDropdown } from '.';

export const WITHOUT_APPROPRIATION = 'Sem apropriação';

const userLabel = user => user.last_name || user.username;

class InputDropdownAppropriatedBy extends React.Component {
  state = {
    options: [],
  }

  componentDidMount() {
    fetchUsers('', { is_staff: true })
      .then((data) => {
        this.setState({
          options: [
            { value: WITHOUT_APPROPRIATION, label: WITHOUT_APPROPRIATION },
            ...(data.results || []).map(user => ({ value: user.id, label: userLabel(user) })),
          ],
        });
      })
      .catch(() => undefined);
  }

  render() {
    const { ...rest } = this.props;
    const { options } = this.state;

    return (
      <InputTypeDropdown
        field="document_approval_appropriated_by"
        label="Apropriado por"
        options={options}
        {...rest}
      />
    );
  }
}

export default InputDropdownAppropriatedBy;
